// Palette a project label can be painted with. Stored the way the backend stores
// a label colour — no leading `#`; add it where the value goes into CSS.
export const LABEL_COLORS = [
  '0F7C86',
  '00821D',
  '3B7DA1',
  'BA42AE',
  'D0386F',
  '4247BA',
  '715FA7',
  'A85510',
  'B03A3A',
  'C0871B',
  '5F8C1F',
  '2A4A7A',
  '6B7080',
];

// Same name always lands on the same colour, so a tag looks stable before it exists.
export const labelColorFor = name => LABEL_COLORS[
  [...name].reduce((sum, ch) => sum + ch.charCodeAt(0), 0) % LABEL_COLORS.length
];
